Vue.component('toggle', {
	props: ['defaultValue'],
    data: function() {
        return {
            toggleValue: null,
            isMounted: false,
        };
    },
    watch: {
        toggleValue: function() {
            jQuery(this.$el).find('.error-message').remove(); // Quickfix

            if(this.isMounted) {
                if(this.toggleValue === 'vrij') {
                    this.$nextTick(function() {
                        window.startTiny()
                    });
                }
                else {
                    this.$nextTick(function() {
                        window.stopTiny()
                    });
                }
            }
        }
    },
    beforeMount: function() {
    	if (this.defaultValue) {
    		this.toggleValue = this.defaultValue;
    	}
    },
    mounted: function() {
        //
        var that = this;
        setTimeout(function() {
            that.isMounted = true;
        }, 1000)

        $('#modal-profile-edit').on('show.bs.modal', function (e) {
            if(that.toggleValue === 'vrij') {
                window.startTiny()
            }
        })
    }
});